// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"64":"bd05db99","150":"fd5a6ad2","229":"0858b67c","709":"cc636b22","731":"8afd0dcb"}[chunkId] + ".chunk.js");